module.exports = "pegasus/assets/theme6/medium/5.jpg";